import * as React from 'react'
import { FC } from 'react'

import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const footerItemStyle = {
  ':hover': {
    backgroundColor: 'transparent',
  },
  textDecoration: 'none',
}

export const Footer: FC = () => {
  return (
    <Stack direction="row" gap={3} justifyContent="space-between" flex="unset">
      <Link
        variant="caption"
        sx={footerItemStyle}
        href="https://www.workwave.com/pestpac/community"
        target="_blank"
      >
        Community Site
      </Link>
      <Link
        variant="caption"
        sx={footerItemStyle}
        href="https://www.workwave.com/privacy-policy/"
        target="_blank"
      >
        Privacy Policy
      </Link>
      <Link
        variant="caption"
        sx={footerItemStyle}
        href="https://www.workwave.com/end-of-life-policy/"
        target="_blank"
      >
        End of Life Policy
      </Link>

      <Typography variant="caption">All Rights Reserved</Typography>
    </Stack>
  )
}
Footer.displayName = 'Footer'
